<app-pcbread-crumb [data]="'CustomerSupport,HealthyProduct,Essential'"></app-pcbread-crumb>
<app-salamat-product
  [endPoint]="'Essential'"
  [pageName]="'Essential'"
  [productType]="productType"
></app-salamat-product>
